import { Component, Directive } from '@angular/core';
import { DesignBlockMode, WebsiteBlockDisplayItem, WebsiteBlockTextAndMediaDisplayItem, WebsiteBlockTextAndMediaImageDisplayItem, WebsiteBlockTextAndMediaType, WebsiteHostingType, WebsiteRenderContextDisplayItem, WebsiteScriptCodeDisplayItem } from '@sb/library/data-models';
import { TextBlockElementKind, WebsiteMode } from '../definitions/design-blocks.definitions';
import { WebsiteBlockAction, WebsiteBlockImageAction } from '../definitions/website.definitions';
import { BaseViewComponent } from './base-view.component';
import { Field, Scope } from '../base';

export class DesignBlockScope extends Scope {
    websiteBlockData = Field<WebsiteBlockDisplayItem>();
}

export class DesignBlockTextAndMediaScope extends DesignBlockScope {
    override websiteBlockData = Field<WebsiteBlockTextAndMediaDisplayItem>();
}

export class DesignBlockImageScope extends Scope {
    imageData = Field<WebsiteBlockTextAndMediaImageDisplayItem>();
}

/// file:///C:/Git/SchoolBox/SchoolBox.AngularFrontend/projects/library/website/page/website-page.component.ts
export class WebsitePageScope extends Scope {
    websiteMode = Field<WebsiteMode>();
    renderContext = Field<WebsiteRenderContextDisplayItem>();
    hostingType = Field<WebsiteHostingType>();
    websiteBlockCount = Field<number>();
    scriptCodes = Field<WebsiteScriptCodeDisplayItem[]>();

    HandleBlockAction = Field<(block: WebsiteBlockDisplayItem, action: WebsiteBlockAction) => void>();
    HandleImageAction = Field<(block: WebsiteBlockDisplayItem.WithImages, action: WebsiteBlockImageAction, index: number) => void>();
}

@Directive()
export abstract class DesignBlockBaseViewComponent extends BaseViewComponent implements DesignBlockScope {
    readonly Scope = this.SetScope({
        Implements: DesignBlockScope,
        Requires: WebsitePageScope
    });

    readonly WebsiteBlockTextAndMediaType = WebsiteBlockTextAndMediaType;
    readonly TextBlockElementKind = TextBlockElementKind;
    readonly WebsiteMode = WebsiteMode;
    readonly DesignBlockMode = DesignBlockMode;
    readonly WebsiteBlockAction = WebsiteBlockAction

    // Implement as input on all website block components
    abstract websiteBlockData: WebsiteBlockDisplayItem;

    get designBlockMode(): DesignBlockMode {
        return this.websiteBlockData.DesignBlockMode ?? DesignBlockMode.Live;
    }

}
